"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userUrl = exports.authScope = exports.authAudience = exports.authDomain = exports.authClientId = exports.apiUrl = void 0;
const config_1 = require("../config");
exports.apiUrl = config_1.yodaApiUrl; // e.g. https://api.qa.simplisafe.com
exports.authClientId = config_1.yodaClientId; // e.g. T7eCeimOOcFOmQgkx4ycNL6Sm7eJn7lW
exports.authDomain = config_1.yodaAuthDomain; // e.g. qa.auth.simplisafe.com
exports.authAudience = 'https://api.simplisafe.com/';
exports.authScope = 'openid profile email offline_access https://api.simplisafe.com/scopes/read:users https://api.simplisafe.com/scopes/read:payment';
exports.userUrl = `${exports.apiUrl}/v1/users`;
//# sourceMappingURL=yoda.js.map